<template>
  <div class="all-page">
    <div
      class="left-part"
      :class="!getSocializationFold ? '' : 'left-part-close'"
    >
      <!-- 左侧 -->
      <div class="left-part-1" v-if="!getSocializationFold">
        <div class="left-part-1-top">
          <div>
            <div class="item-class">
              <img
                src="../../assets/images/socializationIcon/block/icon_num_nz.png"
                alt=""
                srcset=""
              />
              <div class="item-class-right">
                <div class="div-top">农资店铺数量</div>
                <div
                  class="div-bottom"
                  :data-content="
                    numberSeparatorCompute(
                      totalStatistics.materialStationNums,
                      'need'
                    )
                  "
                >
                  {{
                    totalStatistics.materialStationNums
                      | numberSeparatorTofiexed
                  }}<span style="font-family: YouSheBiaoTiHei">{{
                    (totalStatistics.materialStationNums || 0) / 10000 >= 1
                      ? "万"
                      : ""
                  }}</span>
                </div>
              </div>
            </div>
            <div class="item-class">
              <img
                src="../../assets/images/socializationIcon/block/icon_num_wx.png"
                alt=""
                srcset=""
              />
              <div class="item-class-right">
                <div class="div-top">维修站数量</div>
                <div
                  class="div-bottom"
                  :data-content="
                    numberSeparatorCompute(
                      totalStatistics.repairStationNums,
                      'need'
                    )
                  "
                >
                  {{
                    totalStatistics.repairStationNums | numberSeparatorTofiexed
                  }}<span style="font-family: YouSheBiaoTiHei">{{
                    (totalStatistics.repairStationNums || 0) / 10000 >= 1
                      ? "万"
                      : ""
                  }}</span>
                </div>
              </div>
            </div>
            <div class="item-class">
              <img
                src="../../assets/images/socializationIcon/block/icon_num_jx.png"
                alt=""
                srcset=""
              />
              <div class="item-class-right">
                <div class="div-top">经销商数量</div>
                <div
                  class="div-bottom"
                  :data-content="
                    numberSeparatorCompute(
                      totalStatistics.sellingStationNums,
                      'need'
                    )
                  "
                >
                  {{
                    totalStatistics.sellingStationNums
                      | numberSeparatorTofiexed
                  }}<span style="font-family: YouSheBiaoTiHei">{{
                    (totalStatistics.sellingStationNums || 0) / 10000 >= 1
                      ? "万"
                      : ""
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="item-class">
              <img
                src="../../assets/images/socializationIcon/block/icon_num_nh.png"
                alt=""
                srcset=""
              />
              <div class="item-class-right">
                <div class="div-top">发布农活数</div>
                <div
                  class="div-bottom"
                  :data-content="
                    numberSeparatorCompute(totalStatistics.workNums, 'need')
                  "
                >
                  {{ totalStatistics.workNums | numberSeparatorTofiexed
                  }}<span style="font-family: YouSheBiaoTiHei">{{
                    (totalStatistics.workNums || 0) / 10000 >= 1 ? "万" : ""
                  }}</span>
                </div>
              </div>
            </div>
            <div class="item-class">
              <img
                src="../../assets/images/socializationIcon/block/icon_num_sp.png"
                alt=""
                srcset=""
              />
              <div class="item-class-right">
                <div class="div-top">视频播放量</div>
                <div
                  class="div-bottom"
                  :data-content="
                    numberSeparatorCompute(
                      totalStatistics.totalPlayNums,
                      'need'
                    )
                  "
                >
                  {{ totalStatistics.totalPlayNums | numberSeparatorTofiexed
                  }}<span style="font-family: YouSheBiaoTiHei">{{
                    (totalStatistics.totalPlayNums || 0) / 10000 >= 1
                      ? "万"
                      : ""
                  }}</span>
                </div>
              </div>
            </div>
            <div class="item-class">
              <img
                src="../../assets/images/socializationIcon/block/icon_num_bf.png"
                alt=""
                srcset=""
              />
              <div class="item-class-right">
                <div class="div-top">帮扶农户数</div>
                <div
                  class="div-bottom"
                  :data-content="
                    numberSeparatorCompute(totalStatistics.farmerNums, 'need')
                  "
                >
                  {{ totalStatistics.farmerNums | numberSeparatorTofiexed
                  }}<span style="font-family: YouSheBiaoTiHei">{{
                    (totalStatistics.farmerNums || 0) / 10000 >= 1 ? "万" : ""
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="left-part-1-center">
          <div class="common-title">
            <div class="title">
              <span>农活热点区域排行</span>
            </div>
            <div class="date-picker">
              <el-date-picker
                v-model="timeRange"
                type="monthrange"
                range-separator="--"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
                value-format="yyyy-MM"
                popper-class="custom-date-picker"
              >
              </el-date-picker>
            </div>
          </div>
          <div
            class="farm-work-box"
            v-if="
              leftCenterData.firstList && leftCenterData.firstList.length > 0
            "
          >
            <div class="farm-work-box-header">
              <div class="first"></div>
              <div class="second ellipsis">所属区域</div>
              <div class="third ellipsis">发布数量</div>
              <div class="fourth ellipsis">主要作业类型</div>
            </div>
            <!-- 前三名 -->
            <!-- eslint-disable vue/no-use-v-if-with-v-for -->
            <div
              v-if="
                leftCenterData.firstList && leftCenterData.firstList.length > 0
              "
              class="farm-work-first"
              v-for="(v, i) in leftCenterData.firstList"
              :key="i"
              @mouseenter="showWorkPopup(v, 'first', $event)"
              @mouseleave="hideWorkPopup('first')"
            >
              <img
                :src="
                  require(`../../assets/images/socializationIcon/block/num_${
                    i + 1
                  }.png`)
                "
              />
              <div class="second ellipsis">{{ v.areaName || "" }}</div>
              <div class="third ellipsis">{{ v.nums || 0 }}</div>
              <div class="fourth ellipsis">{{ v.jobTypeNames || "" }}</div>
            </div>
            <!-- 第4名往后 -->
            <div
              class="scroll-container"
              v-if="
                leftCenterData.secondList &&
                leftCenterData.secondList.length >= 1
              "
            >
              <div
                class="list-box"
                :style="{ transform: `translateY(${scrollTop}px)` }"
              >
                <div
                  class="farm-work-first"
                  v-for="(v, i) in leftCenterData.secondList"
                  :key="i"
                  @mouseenter="showWorkPopup(v, 'second', $event)"
                  @mouseleave="hideWorkPopup('second')"
                >
                  <div class="first">
                    <div style="color: #b9ffdc">{{ i + 4 }}</div>
                  </div>
                  <div class="second ellipsis">{{ v.areaName || "" }}</div>
                  <div class="third ellipsis">{{ v.nums || 0 }}</div>
                  <div class="fourth ellipsis">{{ v.jobTypeNames || "" }}</div>
                </div>

                <div
                  v-if="
                    leftCenterData.secondList &&
                    leftCenterData.secondList.length > 3
                  "
                  class="farm-work-first"
                  v-for="(v, i) in leftCenterData.secondList"
                  :key="i + 100"
                  @mouseenter="showWorkPopup(v, 'second', $event)"
                  @mouseleave="hideWorkPopup('second')"
                >
                  <div class="first">
                    <div>{{ i + 4 }}</div>
                  </div>
                  <div class="second ellipsis">{{ v.areaName || "" }}</div>
                  <div class="third ellipsis">{{ v.nums || 0 }}</div>
                  <div class="fourth ellipsis">{{ v.jobTypeNames || "" }}</div>
                </div>
              </div>
            </div>
            <div v-else style="flex: 1"></div>
          </div>
          <div v-else class="empty_panel"></div>
        </div>
        <div class="left-part-1-bottom">
          <div class="common-title">
            <div class="title">
              <span>车辆租赁和二手交易</span>
            </div>
          </div>
          <vue-seamless-scroll
            :data="rentVehicleData"
            class="rent-vehicle-seamless-warp"
            :class-option="{ ...classOption, limitMoveNum: 3 }"
            v-if="rentVehicleData && rentVehicleData.length > 0"
          >
            <div
              class="rent-vehicle-item"
              v-for="(item, index) in rentVehicleData"
              :key="index"
            >
              <div class="item-left">
                <img
                  class="dot"
                  src="../../assets/images/socializationIcon/block/dk_dot.png"
                />
                <img
                  class="line"
                  src="../../assets/images/socializationIcon/block/dk_line.png"
                />
              </div>
              <div class="item-right">
                <div class="item-right-top">
                  <img
                    :key="index"
                    :src="
                      require(`../../assets/images/socializationIcon/block/${
                        item.type == 2 ? 'icon_njzl' : 'icon_escz'
                      }.png`)
                    "
                    alt=""
                    srcset=""
                  />
                  <div>{{ item.brandName }}</div>
                  <div>{{ item.vehicleModuleName }}</div>
                </div>
                <div class="item-right-bottom">
                  <div class="item-right-bottom-left">
                    <div class="item-right-bottom-left-top">
                      {{ item.vehicleTypeName }}
                    </div>
                    <div class="item-right-bottom-left-bottom ellipsis">
                      {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      {{ item.phone }}
                    </div>
                    <div class="item-right-bottom-left-bottom ellipsis">
                      {{ item.areaName }}
                    </div>
                  </div>
                  <div
                    class="item-right-bottom-right"
                    :class="
                      item.type == 1
                        ? 'item-right-bottom-right-yellow'
                        : 'item-right-bottom-right-blue'
                    "
                  >
                    <template v-if="item.priceType == 1">
                      <div>面议</div>
                    </template>
                    <template v-else>
                      <div>
                        {{
                          item.price && item.price >= 10000
                            ? Number(item.price / 10000).toFixed(1)
                            : item.price || 0
                        }}
                      </div>
                      <div>
                        {{ item.price && item.price >= 10000 ? "万" : ""
                        }}{{
                          item.type == 1
                            ? "元"
                            : item.per == 1
                            ? "元/天"
                            : "元/月"
                        }}
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </vue-seamless-scroll>
          <div v-else class="empty_panel"></div>
        </div>
      </div>
      <div v-else class="left-part-1-hidden"></div>
      <!-- 选择条件 -->
      <div class="left-part-2">
        <div
          v-for="(item, index) in allTypeList"
          @click="selectType(item)"
          class="left-part-2-item"
          :key="index"
        >
          <img
            :class="item.className"
            :src="item.active ? item.iconUrl : item.iconUrl_"
            alt=""
            srcset=""
          />
        </div>

        <img
          v-if="!getSocializationFold"
          @click="foldSocialization(true)"
          class="btn_open"
          :class="isFoldSkill ? 'btn_open_right' :  ''"
          src="../../assets/images/socializationIcon/icon_qp.png"
          alt=""
          srcset=""
        />
        <img
          v-else
          class="open_fold"
          @click="foldSocialization(false)"
          src="../../assets/images/socializationIcon/icon_qp_n_c.png"
          alt=""
          srcset=""
        />
      </div>
    </div>

    <!-- 农活热点区域排行 弹窗-->
    <div
      class="farm-work-fixed-popup"
      :style="{ top: `${popupTop}px` }"
      v-show="farmWorkSeleted.areaName"
    >
      <div class="popup-area">{{ farmWorkSeleted.areaName }}</div>
      <div class="popup-num">发布农活总数</div>
      <div class="popup-num" style="border-bottom: 1px solid #056e47">
        {{ farmWorkSeleted.nums || 0 }}
      </div>
      <div class="popup-list">
        <div class="popup-list-header">
          <div>作业类型</div>
          <div>次数</div>
        </div>
        <vue-seamless-scroll
          :data="farmWorkSeleted.details"
          class="farm-work-fixed-popup-seamless-warp"
          :class-option="{ ...classOption, limitMoveNum: 6 }"
          v-if="farmWorkSeleted.details"
        >
          <div
            class="popup-list-header"
            v-for="(item, i) in farmWorkSeleted.details"
            :key="i"
          >
            <div>{{ item.name }}</div>
            <div>{{ item.nums }}</div>
          </div>
        </vue-seamless-scroll>

        <!-- <div class="popup-list-header" v-for="item in farmWorkSeleted.everyType">
          <div>{{item.name}}</div>
          <div>{{item.num}}</div>
        </div> -->
      </div>
    </div>

    <!-- 右侧 -->
    <div
      class="right-part"
      :class="getSocializationFold || isFoldSkill ? 'right-part-close' : ''"
    >
      <div
        class="right-part-top"
        :style="isMoreVideo ? {} : { 'border-width': 0 }"
      >
        <div class="common-title" @click="foldSkill">
          <div class="title">
            <span>农技推广宣传</span>
          </div>
        </div>
        <template v-if="videoList.length > 0">
          <div
            class="div_video"
            @mouseenter="mouseenterVedio"
            @mouseleave="mouseleaverVedio"
          >
            <div>
              <video-player
                ref="videoPlayer"
                class="div-video-player"
                :options="playerOptions"
                @ended="onVideoEnded"
              ></video-player>
              <div @click="openVideoWindow" class="div_video_mask"></div>
            </div>
            <transition
              name="animate__animated animate__bounce"
              enter-active-class="animate__fadeIn"
              leave-active-class="animate__fadeOut"
            >
              <div class="controls animate__animated" v-show="showControls">
                <img
                  @click="prevVideo"
                  :disabled="currentIndex === 0"
                  src="../../assets/images/socializationIcon/block/btn_switch_left.png"
                />
                <img
                  @click="nextVideo"
                  :disabled="currentIndex === videoList.length - 1"
                  src="../../assets/images/socializationIcon/block/btn_switch_right.png"
                />
              </div>
            </transition>
            <!-- <div class="open-dialog-btn" @click="openVideoWindow">弹窗</div>  -->
          </div>
          <div class="video-title">
            <div
              :class="
                videoList[currentIndex].videoTitle &&
                videoList[currentIndex].videoTitle.length >= 23
                  ? 'title-animation'
                  : ''
              "
            >
              {{
                videoList[currentIndex] && videoList[currentIndex].videoTitle
              }}
            </div>
          </div>
          <div
            class="more-video"
            :class="isMoreVideo ? 'more-video-open' : ''"
            ref="moreVideoRef"
          >
            <div class="more-video-list" ref="videoListRef">
              <div
                class="more-video-item"
                v-for="(item, index) in videoList"
                :key="index"
                :class="{ 'video-active': currentIndex === index }"
                @click="selectedVideo(index)"
              >
                <img :src="item.videoCoverPicturePath || ''" />
                <div class="two-ellipsis">{{ item.videoTitle || "" }}</div>
              </div>
            </div>
          </div>
          <div
            class="more-video-btn"
            v-if="videoList.length > 1"
            @click="isMoreVideo = !isMoreVideo"
          >
            >> {{ isMoreVideo ? "查看更多视频" : "收起视频列表" }} &lt;&lt;
          </div>
        </template>
        <template v-else>
          <div class="video-empty"></div>
        </template>
      </div>
      <template v-if="knowledgeData.length > 0">
        <div
          class="right-part-bottom"
          :class="
            isMoreVideo ? 'seamless-warp-height' : 'seamless-warp-no-height'
          "
        >
          <vue-seamless-scroll
            :data="knowledgeData"
            class="knowledge-item-seamless-warp"
            :class-option="{ ...classOption, limitMoveNum: 3 }"
            v-if="knowledgeData && knowledgeData.length > 0"
          >
            <div
              class="knowledge-item"
              v-for="(item, index) in knowledgeData"
              :key="index"
            >
              <div class="knowledge-item-title ellipsis">
                {{ item.title }}
              </div>
              <div class="knowledge-item-bottom">
                <div class="knowledge-item-bottom-left">
                  <div class="knowledge-item-department">
                    <img
                      src="../../assets/images/socializationIcon/block/icon_fbr.png"
                    />
                    <div>{{ item.senderUserName }}</div>
                  </div>
                  <div
                    class="knowledge-item-content two-ellipsis"
                    v-html="item.msgContent || '--'"
                    :style="{ color: '#FFFFFF' }"
                  ></div>
                </div>
                <img
                  class="knowledge-item-bottom-right"
                  :src="
                    !item.displayImageUrl
                      ? require('../../assets/images/socializationIcon/block/pic_nj_mrt.png')
                      : item.displayImageUrl
                  "
                />
              </div>
            </div>
          </vue-seamless-scroll>
        </div>
      </template>
      <template v-else>
        <div class="knowledge-empty">暂无农技知识内容 请前往管理端上传！</div>
      </template>
    </div>
    <div class="right-fold-skill" @click="foldSkill" v-if="isFoldSkill"></div>

    <!-- 下 -->
    <div
      class="bottom-part"
      :class="!getSocializationFold ? '' : 'bottom-part-close'"
    >
      <div class="bottom-part-1">
        <div class="common-title">
          <div class="title special-margin">
            <!-- <span>{{ isProvinceLevel ? "各地市" : "各县区" }}店铺数量分布</span> -->
            <span>各乡镇店铺数量分布</span>
          </div>
        </div>
        <barChart
          v-if="barChart.shopList && barChart.shopList.length > 0"
          :chartData="barChart"
          height="90%"
        ></barChart>
        <div v-else class="empty_panel"></div>
      </div>
      <div class="bottom-part-2">
        <div class="common-title">
          <div class="title">
            <span>机手画像</span>
          </div>
          <div class="age-tabs">
            <div
              @click="hotTab(1, 'age')"
              :class="{ 'hot-tab-active': ageTabSelected == 1 }"
            >
              驾龄分布
            </div>
            <div
              @click="hotTab(2, 'age')"
              :class="{ 'hot-tab-active': ageTabSelected == 2 }"
            >
              年龄分布
            </div>
          </div>
        </div>
        <pieChart :optionData="pieData" v-if="pieData.length && !isZero" />
        <div style="flex: 1" class="empty_panel" v-else></div>
      </div>
      <div class="bottom-part-3">
        <div class="common-title">
          <div class="title special-margin">
            <span>热门农机/农资/农产品</span>
          </div>
          <div class="hot-tabs">
            <div
              @click="hotTab(1, 'hot')"
              :class="{ 'hot-tab-active': hotTabSelected == 1 }"
            >
              热门农机
            </div>
            <div
              @click="hotTab(2, 'hot')"
              :class="{ 'hot-tab-active': hotTabSelected == 2 }"
            >
              热门农资
            </div>
            <div
              @click="hotTab(3, 'hot')"
              :class="{ 'hot-tab-active': hotTabSelected == 3 }"
            >
              热门农产品
            </div>
          </div>
        </div>
        <div class="bottom-part-3-bottom">
          <div class="hot-podium">
            <div class="first">
              <div :class="[hotTabSelected == 3 ? 'two-ellipsis-product' : '']">
                {{
                  rightBottomData.selected.firstList[0]
                    ? rightBottomData.selected.firstList[0].brandName
                    : ""
                }}
              </div>
              <!-- <div class="ellipsis" v-if="hotTabSelected != 3">{{rightBottomData.selected.firstList[0] ? rightBottomData.selected.firstList[0].brandName : ''}}</div> -->
              <div class="ellipsis" v-if="hotTabSelected != 3">
                {{
                  rightBottomData.selected.firstList[0]
                    ? rightBottomData.selected.firstList[0].type
                    : ""
                }}
              </div>
              <div class="ellipsis">
                {{
                  rightBottomData.selected.firstList[0]
                    ? rightBottomData.selected.firstList[0].count + "次"
                    : ""
                }}
              </div>
            </div>
            <div class="second">
              <div :class="[hotTabSelected == 3 ? 'two-ellipsis-product' : '']">
                {{
                  rightBottomData.selected.firstList[1]
                    ? rightBottomData.selected.firstList[1].brandName
                    : ""
                }}
              </div>
              <!-- <div class="ellipsis">{{rightBottomData.selected.firstList[1] ? rightBottomData.selected.firstList[1].brandName : ''}}</div> -->
              <div class="ellipsis" v-if="hotTabSelected != 3">
                {{
                  rightBottomData.selected.firstList[1]
                    ? rightBottomData.selected.firstList[1].type
                    : ""
                }}
              </div>
              <div class="ellipsis">
                {{
                  rightBottomData.selected.firstList[1]
                    ? rightBottomData.selected.firstList[1].count + "次"
                    : ""
                }}
              </div>
            </div>
            <div class="third">
              <div :class="[hotTabSelected == 3 ? 'two-ellipsis-product' : '']">
                {{
                  rightBottomData.selected.firstList[2]
                    ? rightBottomData.selected.firstList[2].brandName
                    : ""
                }}
              </div>
              <!-- <div class="ellipsis">{{rightBottomData.selected.firstList[2] ? rightBottomData.selected.firstList[2].brandName : ''}}</div> -->
              <div class="ellipsis" v-if="hotTabSelected != 3">
                {{
                  rightBottomData.selected.firstList[2]
                    ? rightBottomData.selected.firstList[2].type
                    : ""
                }}
              </div>
              <div class="ellipsis">
                {{
                  rightBottomData.selected.firstList[2]
                    ? rightBottomData.selected.firstList[2].count + "次"
                    : ""
                }}
              </div>
            </div>
          </div>
          <div class="hot-rank">
            <div class="hot-rank-header">
              <div class="first"></div>
              <div class="second ellipsis">
                {{ rightBottomData.selected.name[0] }}
              </div>
              <div class="third ellipsis">
                {{ rightBottomData.selected.name[1] }}
              </div>
              <div class="fourth ellipsis">
                {{ rightBottomData.selected.name[2] }}
              </div>
            </div>
            <vue-seamless-scroll
              @ScrollEnd="scrollEnd"
              :data="rightBottomData.selected.secondList"
              class="hot-rank-seamless-warp"
              :class-option="{ ...classOption, limitMoveNum: 4 }"
              v-if="rightBottomData.selected.secondList.length >= 1"
            >
              <div
                class="hot-rank-item"
                v-for="(v, i) in rightBottomData.selected.secondList"
                :key="i"
              >
                <div class="hot-rank-item-left">
                  {{ i + 4 }}
                </div>
                <div class="hot-rank-header hot-rank-item-right">
                  <div class="second ellipsis">{{ v.brandName }}</div>
                  <div class="third ellipsis">{{ v.type }}</div>
                  <div class="fourth ellipsis">{{ v.count }}</div>
                </div>
              </div>
            </vue-seamless-scroll>
            <div v-else class="emphot-rank-seamless-warp">
              <div class="empty_panel"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <videoWindow
      ref="videoWindowRef"
      :videoList="videoList"
      :currentInd="currentIndex"
      @playVideo="play"
    ></videoWindow>

    <div class="map_container">
      <!-- 农机分布 -->
      <mapModel ref="mapModel" :isFirst="isFirst" :typeList="checkedType" />
    </div>
  </div>
</template>

<script>
import mapModel from "./components/mapModel";
import * as socializationApi from "@/api/socialization";
import { getAreaCount, getVehiclePointListByRadius } from "@/api/home";
import { mapGetters } from "vuex";
import Modal from "@components/modal.vue";
import { parseTime, debounce } from "@/utils/index";
import socializationIconMap from "@/utils/socializationIconType";
import barChart from "./components/barChart.vue";
import pieChart from "./components/pieChart.vue";
import videoWindow from "./components/videoWindow.vue";

export default {
  components: {
    mapModel,
    Modal,
    barChart,
    videoWindow,
    pieChart,
  },
  data() {
    return {
      // 社会化统计总数
      totalStatistics: {
        // 农资店铺数量
        materialStationNums: 0,
        //维修站数量
        repairStationNums: 0,
        //经销点数量
        sellingStationNums: 0,
        //发布农活数
        workNums: 0,
        //视频播放量
        totalPlayNums: 0,
        //帮扶农户数
        farmerNums: 0,
      },
      // 是否是省级单位
      isProvinceLevel: true,
      // 所需社会化类型
      needSocializationType: ["8", "0", "1", "2", "3", "4", "5", "6", "7", "9"],
      socializationIconMap,
      // 所有类型
      allTypeList: [],
      // 选中类型
      checkedType: ["8"],
      // 农活热点时间选择器
      timeRange: [],
      // 农活滚动距离
      scrollTop: 0,
      //农活热点区域高度
      boxDomHeight: 0,
      // 清空定时器
      clearInt: null,
      popupTop: 0,
      // 被选中农活列表
      farmWorkSeleted: {
        areaName: "",
        nums: "",
        jobTypeNames: [],
      },
      // 车辆租赁和二手交易
      rentVehicleData: [
        // {type: 1, brandName: '东方红',  vehicleModuleName:'LX1801', vehicleTypeName: '轮式拖拉机1', owner: '郭国占1', phone: '18737292888', address: '河南省鹤壁市淇县西岗镇南大李庄村342米大李庄村342米大李庄村342米'},
      ],
      // 农活热点区域排行
      leftCenterData: {
        firstList: [],
        secondList: [],
      },
      pieData: [],
      // 驾龄分布
      driveAge: [
        {
          key: "lt3YearsNums",
          name: "小于3年",
          value: 0,
        },
        {
          key: "bt3And10YearsNums",
          name: "3-10年",
          value: 0,
        },
        {
          key: "gt10YearsNums",
          name: "10年以上",
          value: 0,
        },
      ],
      // 年龄分布
      profileAge: [
        {
          key: "bt18And40YearsNums",
          name: "18-40岁",
          value: 0,
        },
        {
          key: "bt41And60YearsNums",
          name: "41-60岁",
          value: 0,
        },
        {
          key: "gt60YearsNums",
          name: "60岁以上",
          value: 0,
        },
      ],
      // 是否饼状图值都为0
      isZero: true,
      isZeroObj: {
        profileAge: true,
        driveAge: true,
      },
      // 各乡镇店铺数量分布
      barChart: {
        shopList: [],
        legends: [],
      },
      // 被选中热门农机、农资、农产品
      hotTabSelected: 1,
      // 被选中驾龄、年龄
      ageTabSelected: 1,
      // 热门农机、农资、农产品列表
      rightBottomData: {
        popularVehicle: {
          key: "1",
          name: ["农机品牌", "农机型号", "咨询量(次)"],
          firstList: [],
          secondList: [],
        },
        popularMaterial: {
          key: "2",
          name: ["农资品牌", "农资品种", "咨询量(次)"],
          firstList: [],
          secondList: [],
        },
        popularProduct: {
          key: "3",
          name: ["农产品名称", "", "咨询量(次)"],
          firstList: [],
          secondList: [],
        },
        selected: {
          key: "1",
          name: ["农机品牌", "农机型号", "咨询量(次)"],
          firstList: [],
          secondList: [],
        },
      },
      // 年龄 、驾龄定时器
      ageTimeOut: null,
      // 热门农机定时器
      timeOut: null,
      // 是否折叠农机推广宣传
      isFoldSkill: false,
      //视频相关
      currentIndex: 0,
      scrollDistance: 50,
      videoList: [],
      // 展示上一个、下一个按钮
      showControls: false,
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        autoplay: true,
        muted: true,
        loop: false,
        preload: "auto",
        language: "zh-CN",
        sources: [
          {
            type: "video/mp4",
            src: "", // 初始为空，将在mounted钩子中设置
          },
        ],
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: false,
        // controlBar: {
        //   timeDivider: true,
        //   durationDisplay: true,
        //   remainingTimeDisplay: false,
        //   fullscreenToggle: true,
        //   playToggle: true,
        //   progressControl: true,
        //   playbackRateMenuButton: false,
        //   volumePanel: false,
        // },
        volumePanel: {
          inline: false, // 设为false则为垂直
        },
      },
      // 更多视频
      isMoreVideo: true,
      // 技能知识列表
      knowledgeData: [],
      // 农技视频、农技知识数量
      bothSkill: {
        showVideo: true,
        showKnowle: true,
      },
      isFirst: true,
    };
  },
  name: "Socialization",
  beforeUnmount() {
    clearInterval(this.clearInt);
  },
  methods: {
    initPageData() {
      this.getTotalStatistics();
      this.getUsedMachinery();
      this.getPopularVehicle();
      this.getPopularProduct();
      this.getPopularMaterial();
      this.getVideoList();
      this.getPreachList();
      this.getAgeProfile();
      this.getDriveYearProfile();
      this.getMapStatistics();
      this.getShopCount();
    },
    // 农事通大屏-地图数据-聚合数据
    getMapStatistics(latitude, longitude, radius) {
      socializationApi
        .getMapStatistics({
          queryTypes: this.checkedType.join(","),
          latitude,
          longitude,
          radius,
        })
        .then((res) => {
          this.$refs.mapModel.resetAreaCount(res);
        });
    },
    // 农事通大屏-机手画像-年龄
    getAgeProfile() {
      socializationApi.getAgeProfile().then((res) => {
        let result = res || {};
        for (let i = 0; i < this.profileAge.length; i++) {
          this.profileAge[i].value = result[this.profileAge[i].key] || 0;
        }
        this.isZeroObj.profileAge = this.profileAge.every(
          (item) => item.value == 0
        );
      });
    },
    // 农事通大屏-机手画像-驾龄
    getDriveYearProfile() {
      socializationApi.getDriveYearProfile().then((res) => {
        let result = res || {};
        for (let i = 0; i < this.driveAge.length; i++) {
          this.driveAge[i].value = result[this.driveAge[i].key] || 0;
        }
        this.isZeroObj.driveAge = this.driveAge.every(
          (item) => item.value == 0
        );
        this.isZero = this.isZeroObj.driveAge;
      });
    },
    // 鼠标移入视频
    mouseenterVedio() {
      if (this.videoList.length > 1) {
        this.showControls = true;
      }
    },
    // 鼠标移出视频
    mouseleaverVedio() {
      this.showControls = false;
    },
    // 打开视频弹窗
    openVideoWindow() {
      this.pause();
      this.$refs.videoWindowRef.open();
    },
    // 获取农技知识列表
    getPreachList() {
      socializationApi.getPreachList().then((res) => {
        this.knowledgeData = res || [];
        this.bothSkill.showKnowle =
          this.knowledgeData.length > 0 ? true : false;
      });
    },
    // 获取农技推广视频列表
    getVideoList() {
      socializationApi.getVideoList().then((res) => {
        this.videoList = res
          ? res.map((v) => {
              return Object.assign(v, {
                videoFilePath: this.$authFile(v.videoFilePath),
                videoCoverPicturePath: this.$authFile(v.videoCoverPicturePath),
              });
            })
          : [];
        this.bothSkill.showVideo = this.videoList.length > 0 ? true : false;
        if (this.videoList.length <= 1) {
          this.showControls = false;
        }
        if (this.videoList.length > 0) {
          this.playerOptions.sources[0].src =
            this.videoList[this.currentIndex].videoFilePath;
          // this.$refs.videoPlayer.player.ready(() => {
          //   // 可以在这里做一些额外的初始化，比如自动播放第一个视频
          //   // this.$refs.videoPlayer.player.play();
          // });
        }
      });
    },
    // 农事通大屏-热门农机
    getPopularVehicle() {
      socializationApi.getPopularVehicle().then((res) => {
        let allList = res || [];
        allList = allList.map((item) => {
          return {
            brandName: item.brandName,
            type: item.vehicleModuleName,
            count: item.contactNums,
          };
        });
        if (allList.length > 3) {
          this.rightBottomData.popularVehicle.firstList = allList.slice(0, 3);
          this.rightBottomData.popularVehicle.secondList = allList.slice(3);
        } else {
          this.rightBottomData.popularVehicle.firstList = allList;
          this.rightBottomData.popularVehicle.secondList = [];
        }
      });
    },
    // 农事通大屏-热门农资
    getPopularMaterial() {
      socializationApi.getPopularMaterial().then((res) => {
        let allList = res || [];
        allList = allList.map((item) => {
          return {
            brandName: item.brandName,
            type: item.kindName,
            count: item.contactNums,
          };
        });
        if (allList.length > 3) {
          this.rightBottomData.popularMaterial.firstList = allList.slice(0, 3);
          this.rightBottomData.popularMaterial.secondList = allList.slice(3);
        } else {
          this.rightBottomData.popularMaterial.firstList = allList;
          this.rightBottomData.popularMaterial.secondList = [];
        }
      });
    },
    // 农事通大屏-热门农产品
    getPopularProduct() {
      socializationApi.getPopularProduct().then((res) => {
        let allList = res || [];
        allList = allList.map((item) => {
          return {
            brandName: item.commodityName,
            type: "",
            count: item.contactNums,
          };
        });
        if (allList.length > 3) {
          this.rightBottomData.popularProduct.firstList = allList.slice(0, 3);
          this.rightBottomData.popularProduct.secondList = allList.slice(3);
        } else {
          this.rightBottomData.popularProduct.firstList = allList;
          this.rightBottomData.popularProduct.secondList = [];
        }
      });
    },
    // 车辆租赁和二手交易
    getUsedMachinery() {
      socializationApi.getUsedMachinery().then((res) => {
        this.rentVehicleData = res || [];
      });
    },
    // 农活热点区域排行
    getWorkAreaRank() {
      let params = {};
      params.startTime = this.timeRange[0];
      params.endTime = this.timeRange[1];
      socializationApi.getWorkAreaRank(params).then((res) => {
        let allList = res || [];
        if (allList.length > 3) {
          this.leftCenterData.firstList = allList.slice(0, 3);
          this.leftCenterData.secondList = allList.slice(3);
          if (
            this.leftCenterData.secondList &&
            this.leftCenterData.secondList.length > 3
          ) {
            this.handleLoop();
          } else {
            clearInterval(this.clearInt);
            this.scrollTop = 0;
          }
        } else {
          this.leftCenterData.firstList = allList;
          this.leftCenterData.secondList = [];
        }
      });
    },
    // 农事通大屏-社会化统计总数
    getTotalStatistics() {
      socializationApi.getTotalStatistics().then((res) => {
        if (res) {
          this.totalStatistics = res;
        } else {
          this.totalStatistics = {
            materialStationNums: 0,
            repairStationNums: 0,
            sellingStationNums: 0,
            workNums: 0,
            totalPlayNums: 0,
            farmerNums: 0,
          };
        }
      });
    },
    // 选中更多视频中的一个
    selectedVideo(index) {
      this.currentIndex = index;
      this.playerOptions.sources[0].src =
        this.videoList[this.currentIndex].videoFilePath;
      this.$refs.videoPlayer.player.play(); // 自动播放
    },
    // 全部折叠
    foldSocialization(flag) {
      this.$store.dispatch("setSocializationFold", flag);
      this.isFoldSkill = false;
    },
    // 是否折叠农技推广
    foldSkill() {
      this.isFoldSkill = !this.isFoldSkill;
      if (this.isFoldSkill) {
        this.pause();
      } else {
        this.play();
      }
    },
    // 热门农农机、农产品滚动完切换
    scrollEnd() {
      if (this.rightBottomData.selected.secondList.length) {
        if (this.hotTabSelected == 1) {
          this.hotTabSelected = 2;
        } else if (this.hotTabSelected == 2) {
          this.hotTabSelected = 3;
        } else {
          this.hotTabSelected = 1;
        }
      }
    },
    // 自动滚动
    handleLoop() {
      const getItem = document.querySelector(".farm-work-first");
      if (getItem && getItem.clientHeight) {
        this.boxDomHeight =
          (getItem.clientHeight + 16) * this.leftCenterData.secondList.length;
        this.handleInterval();
      }
    },
    // 列表长度定时器
    handleInterval() {
      clearInterval(this.clearInt);
      this.clearInt = setInterval(() => {
        this.scrollTop -= 1;
        if (this.scrollTop * -1 >= this.boxDomHeight) {
          this.scrollTop = 0;
        }
      }, 100);
    },
    // 展示弹窗
    showWorkPopup(item, type = "first", event) {
      this.popupTop = event.clientY - 50;
      if (type == "first") {
        this.farmWorkSeleted = item;
      } else {
        this.farmWorkSeleted = item;
        clearInterval(this.clearInt);
      }
    },
    // 隐藏弹窗
    hideWorkPopup(type = "first") {
      this.farmWorkSeleted = {
        areaName: "",
        nums: "",
        jobTypeNames: [],
      };
      if (type != "first" && this.leftCenterData?.secondList?.length > 3) {
        this.handleInterval();
      }
    },
    //获取当前年月、3个月前年月
    getYearMonth() {
      let currentDate = new Date();
      let currentYear = currentDate.getFullYear();
      let currentMonth = currentDate.getMonth();
      // 创建数组存储结果
      let months = [];
      // 将当前月份添加到数组
      months.push({
        year: currentYear,
        month:
          currentMonth + 1 <= 9 ? "0" + (currentMonth + 1) : currentMonth + 1,
      });
      // 往前推3个月
      for (let i = 0; i < 2; i++) {
        // 减少月份数
        currentMonth--;
        // 如果月份小于0，则需要减去一年，并将月份设置为11（12月）
        if (currentMonth < 0) {
          currentYear -= 1;
          currentMonth = 11;
        }
        if (i == 1) {
          // 将新的年月组合添加到数组
          months.push({
            year: currentYear,
            month:
              currentMonth + 1 <= 9
                ? "0" + (currentMonth + 1)
                : currentMonth + 1,
          });
        }
      }

      this.timeRange = [
        months[1].year + "-" + months[1].month,
        months[0].year + "-" + months[0].month,
      ];
    },
    // 所选类型
    selectType(item) {
      this.allTypeList.forEach((el) => {
        if (el.socializationTypeCode == item.socializationTypeCode) {
          el.active = !el.active;
        }
      });
      if (item.socializationTypeCode == "8") {
        item.active = true;
        this.allTypeList.forEach((el) => {
          el.active = false;
        });
        this.allTypeList[0].active = true;
        this.checkedType = [];
        this.checkedType.push(this.allTypeList[0]);
      } else {
        this.allTypeList[0].active = false;
        this.checkedType = this.allTypeList.filter((item) => {
          return item.active == true;
        });
        if (this.checkedType.length == 0) {
          this.allTypeList[0].active = true;
          this.checkedType.push(this.allTypeList[0]);
        }
        if (this.checkedType.length > 1) {
          this.allTypeList[0].active = false;
        }
      }

      this.checkedType = this.checkedType.map((item) => {
        return item.socializationTypeCode;
      });
      debounce(this.needReaction, 1200);
    },
    // 需要随类型切换改变的方法
    needReaction() {
      this.getShopCount();
      this.getMapStatistics();
    },
    // 各类型合作社分布数量统计
    getShopCount() {
      let params = {
        queryTypes: this.checkedType.join(","),
      };
      // if (this.selectAllTypeFlag) params.vehicleTypeCode = "";
      socializationApi.getShopCount(params).then((res) => {
        let labelNames = [];
        let names = ["经销商", "加油站", "转运站", "农资站", "维修站"];
        let shopList = [
          {
            type: "sellingStationNums",
            name: "经销商",
            count: [],
          },
          {
            type: "gasStationNums",
            name: "加油站",
            count: [],
          },
          {
            type: "transportStationNums",
            name: "转运站",
            count: [],
          },
          {
            type: "materialStationNums",
            name: "农资站",
            count: [],
          },
          {
            type: "repairStationNums",
            name: "维修站",
            count: [],
          },
          // {
          //   type: 'totalNums',
          //   name: '总数',
          //   count: [],
          // },
        ];
        if (res) {
          res.forEach((item) => {
            if (item.areaName) {
              labelNames.push(
                (item.areaName.length > 4
                  ? item.areaName.slice(0, 3) + "..."
                  : item.areaName) +
                  "," +
                  item.totalNums
              );
            }

            for (let i = 0; i < shopList.length; i++) {
              shopList[i].count.push(item[shopList[i].type]);
            }
          });

          let shopListCopy = shopList;
          let labelNamesCopy = labelNames;
          let that = this;
          if (shopListCopy && shopListCopy.length >= 10) {
            setInterval(function () {
              shopListCopy.push(shopListCopy.shit());
              labelNamesCopy.push(labelNamesCopy.shit());
              that.$set(that.barChart, "shopList", shopListCopy);
              that.$set(that.barChart, "labelNames", labelNamesCopy);
            }, 1000); // 每2秒滚动一次
          } else {
            this.barChart.shopList = shopList;
            this.barChart.labelNames = labelNames;
          }
          this.barChart.legends = names;
        }
      });
    },
    // 热门农机、农资、农产品选中
    hotTab(index, type) {
      if (type == "hot") {
        this.hotTabSelected = index;
      } else {
        if (index == 1) {
          this.isZero = this.isZeroObj.driveAge;
        } else {
          this.isZero = this.isZeroObj.profileAge;
        }
        this.ageTabSelected = index;
      }
    },
    onVideoEnded() {
      this.nextVideo();
    },
    // 播放
    play() {
      this.$refs.videoPlayer.player.play();
    },
    // 暂停
    pause() {
      this.$refs.videoPlayer.player.pause();
    },
    prevVideo() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.playerOptions.sources[0].src =
          this.videoList[this.currentIndex].videoFilePath;
        this.$refs.videoPlayer.player.play(); // 自动播放
      } else {
        this.currentIndex = this.videoList.length - 1;
        this.playerOptions.sources[0].src =
          this.videoList[this.currentIndex].videoFilePath;
        this.$refs.videoPlayer.player.play(); // 自动播放
      }
    },
    nextVideo() {
      if (this.currentIndex < this.videoList.length - 1) {
        this.currentIndex++;
        this.playerOptions.sources[0].src =
          this.videoList[this.currentIndex].videoFilePath;
        this.$refs.videoPlayer.player.play(); // 自动播放
      } else {
        this.currentIndex = 0;
        this.playerOptions.sources[0].src =
          this.videoList[this.currentIndex].videoFilePath;
        this.$refs.videoPlayer.player.play(); // 自动播放
      }
    },
    getNeedSocializationType() {
      let list = this.needSocializationType.map((v) => {
        return {
          socializationTypeCode: this.socializationIconMap[String(v)].code,
          socializationTypeName: this.socializationIconMap[String(v)].name,
          iconUrl_: this.socializationIconMap[String(v)].item_icon_,
          iconUrl: this.socializationIconMap[String(v)].item_icon,
          active: v == "8",
          className: this.socializationIconMap[String(v)].className,
        };
      });
      this.allTypeList = list;
    },
    featureClick() {},
    pointClick() {},
  },
  computed: {
    ...mapGetters(["getactiveRegionObj", "getSocializationFold"]),
    classOption() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
    numberSeparatorCompute() {
      return function (number, type = "no") {
        let regex = /(?!^)(?=(\d{3})+(\.|$))/g;
        if (!number) {
          return 0;
        } else {
          let num = number;
          if (num >= 10000) {
            num = num / 10000;
            num = num.toFixed(1);
            if (type == "need") {
              return num.toString().replace(regex, ".") + "万";
            } else {
              return num.toString().replace(regex, ",");
            }
          } else {
            return num.toString().replace(regex, ",");
          }
        }
      };
    },
  },
  watch: {
    "$store.state.activeRegionObj": {
      deep: true,
      immediate: true,
      handler(val) {
        if (!val.areaCode) return;
        this.isProvinceLevel = val.areaCode == "410000000";
        // const city = val.areaCode.slice(0, -3);
        this.checkedType = ["8"];
        this.getNeedSocializationType();
        this.initPageData();
        this.$nextTick(() => {
          if (this.$refs.mapModel) {
            this.isFirst = true;
            this.$refs.mapModel.addProvince(val.areaCode);
          }
        });
      },
    },
    /** 热门农机、农资、农产品 */
    hotTabSelected: {
      deep: true,
      immediate: true,
      handler(newVal, oldVal) {
        switch (newVal) {
          case 1:
            this.$set(
              this.rightBottomData,
              "selected",
              this.rightBottomData.popularVehicle
            );
            break;
          case 2:
            this.$set(
              this.rightBottomData,
              "selected",
              this.rightBottomData.popularMaterial
            );
            break;
          case 3:
            this.$set(
              this.rightBottomData,
              "selected",
              this.rightBottomData.popularProduct
            );
            break;
          default:
            break;
        }
        clearTimeout(this.timeOut);
        if (
          !this.rightBottomData.selected.secondList.length ||
          this.rightBottomData.selected.secondList.length <= 3
        ) {
          this.timeOut = setTimeout(() => {
            if (this.hotTabSelected == 1) {
              this.hotTabSelected = 2;
            } else if (this.hotTabSelected == 2) {
              this.hotTabSelected = 3;
            } else {
              this.hotTabSelected = 1;
            }
          }, 5000);
        }
      },
    },
    currentIndex: {
      deep: true,
      immediate: true,
      handler(val) {
        this.$nextTick(() => {
          let container = this.$refs.videoListRef;
          if (container) {
            if (container) {
              let childNodes = container.childNodes;
              if (childNodes.length > 0) {
                for (var i = 0; i < childNodes.length; i++) {
                  let child = childNodes[i];
                  if (child.nodeType === Node.ELEMENT_NODE) {
                    // 确保是元素节点
                    if (childNodes[0] && childNodes[0].offsetHeight) {
                      this.scrollDistance = childNodes[0].offsetHeight;
                      break;
                    }
                  }
                }
              }
              if (
                this.videoList.length > 4 &&
                this.currentIndex <= this.videoList.length - 4
              ) {
                container.scrollTop = this.scrollDistance * Math.floor(val / 2);
              } else {
                if (
                  this.videoList.length >= 5 &&
                  this.currentIndex == this.videoList.length - 1
                ) {
                  container.scrollTop =
                    this.scrollDistance * Math.floor((val - 3) / 2);
                }
              }
            }
          }
        });
      },
    },
    // 机手、驾龄分布
    ageTabSelected: {
      deep: true,
      immediate: true,
      handler(newVal, oldVal) {
        switch (newVal) {
          case 1:
            this.$set(this, "pieData", this.driveAge);
            this.$set(this, "isZero", this.isZeroObj.driveAge);
            break;
          case 2:
            this.$set(this, "pieData", this.profileAge);
            this.$set(this, "isZero", this.isZeroObj.profileAge);
            break;
          default:
            break;
        }
        clearTimeout(this.ageTimeOut);
        this.ageTimeOut = setTimeout(() => {
          if (this.ageTabSelected == 1) {
            this.ageTabSelected = 2;
          } else if (this.ageTabSelected == 2) {
            this.ageTabSelected = 1;
          }
        }, 10000);
      },
    },
    timeRange: {
      deep: true,
      immediate: false,
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.getWorkAreaRank();
        }
      },
    },
    bothSkill: {
      deep: true,
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal.showVideo == false && newVal.showKnowle == false) {
          this.isFoldSkill = true;
        }
      },
    },
  },
  mounted() {
    this.getYearMonth();
    this.$nextTick(() => {
      this.handleLoop();
    });
    this.getShopCount();
  },
  created() {},
};
</script>

<style scoped lang="scss">
@font-face {
  font-family: "Furore"; /* 自定义字体名称 */
  src: url("../../assets/fonts/Furore-2.otf") format("opentype"); /* 路径和格式 */
}
@font-face {
  font-family: "DINPro"; /* 自定义字体名称 */
  src: url("../../assets/fonts/DINPro.ttf") format("truetype"); /* 路径和格式 */
}
@font-face {
  font-family: "YouSheBiaoTiHei"; /* 自定义字体名称 */
  src: url("../../assets/fonts/YOUSHEBIAOTIHEI-2.ttf") format("truetype"); /* 路径和格式 */
}
@import "@assets/css/var.scss";

::v-deep.el-select-dropdown__item,
.option_class {
  text-align: center !important;
}

.all-page {
  width: 100%;
  height: 86vh;
  display: flex;
  position: relative;
  top: vh(-61);
  padding: 0 0 0 vw(16);
  font-family: Microsoft YaHei;
}
.left-part {
  position: relative;
  display: flex;
  z-index: 61;
  left: 0;
  transition: all 300ms;
  .left-part-1-hidden {
    width: vw(414);
  }
  .left-part-1 {
    position: relative;
    display: flex;
    flex-direction: column;
    width: vw(414);

    .left-part-1-top {
      height: vh(284);
      padding: vh(40) vw(4) 0 vw(10);
      background: linear-gradient(
        0deg,
        rgba(4, 28, 12, 0.41),
        rgba(1, 10, 4, 0.3)
      );
      display: flex;
      align-items: center;
      font-family: Microsoft YaHei;
      font-size: fontSize(14);
      color: #ffffff;
      .item-class {
        display: flex;
        align-items: center;
        margin-top: vh(4);
        img {
          width: vw(97);
          height: vh(72);
        }
        .item-class-right {
          margin-left: vw(-6);
          .div-top {
            width: vw(108);
            height: vh(24);
            line-height: vh(24);
            padding-left: vw(6);
            margin-top: vh(-10);
            background: linear-gradient(
              90deg,
              rgba(0, 194, 31, 0.3) 0%,
              rgba(17, 173, 114, 0.3) 0%,
              rgba(86, 209, 172, 0.03) 100%
            );
          }
          .div-bottom {
            margin-top: vh(4);
            position: relative;
            font-family: Furore;
            font-size: fontSize(20);
            background: linear-gradient(
              180deg,
              #ffffff 34.6923828125%,
              #bdffcc 100%
            );
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            font-weight: 600;
          }
          .div-bottom::before {
            content: attr(data-content);
            position: absolute;
            top: 0;
            left: 0;
            z-index: -1;
            color: transparent;
            text-shadow: 0 0 8px rgba(0, 255, 208, 1); /* 第四层阴影 */
          }
        }
      }
    }
    .left-part-1-center {
      display: flex;
      flex-direction: column;
      margin-top: vh(16);
      height: vh(308);
      background: linear-gradient(
        0deg,
        rgba(4, 28, 12, 0.41),
        rgba(1, 10, 4, 0.3)
      );
      .farm-work-box {
        display: flex;
        flex-direction: column;
        padding: 0 vw(9);
        .farm-work-box-header {
          display: flex;
          align-items: center;
          font-size: fontSize(14);
          color: #1bff81;
          margin-bottom: vh(8);
          margin-top: vh(6);
          .first {
            width: vw(44);
          }
          .second {
            width: vw(102);
            padding: 0 vw(6);
            text-align: center;
          }
          .third {
            width: vw(102);
            text-align: center;
          }
          .fourth {
            width: vw(148);
          }
        }
        .farm-work-seamless-warp {
          height: vh(114);
        }
      }
    }
    .left-part-1-bottom {
      display: flex;
      flex-direction: column;
      margin-top: vh(0);
      height: vh(280);
      background: linear-gradient(
        0deg,
        rgba(4, 28, 12, 0),
        rgba(1, 10, 4, 0.33)
      );
      .rent-vehicle-seamless-warp {
        margin-top: vh(12);
        height: vh(230);
        overflow: hidden;
        .rent-vehicle-item {
          display: flex;
          .item-left {
            display: flex;
            flex-direction: column;
            align-items: center;
            height: vh(116);
            width: vw(32);
            position: relative;
            .dot {
              height: vh(40);
              width: vh(40);
            }
            .line {
              margin-top: vh(-14);
              height: vh(110);
              width: vh(2);
            }
          }
          .item-right {
            padding-top: vh(10);
            width: vw(362);
            .item-right-top {
              height: vh(21);
              line-height: vh(21);
              display: flex;
              font-family: Microsoft YaHei;
              font-weight: bold;
              font-size: fontSize(16);
              color: #ffffff;
              margin-bottom: vh(4);
              .img {
                width: vw(66);
                height: vh(22);
              }
              div:nth-child(2) {
                margin: 0 vw(8);
              }
            }
            .item-right-bottom {
              border: 1px solid #149f81;
              display: flex;
              .item-right-bottom-left {
                flex: 1;
                font-size: fontSize(14);
                color: #ffffff;
                font-family: Microsoft YaHei;
                .item-right-bottom-left-top {
                  background-image: url("../../assets/images/socializationIcon/block/bg_list_esnj.png");
                  background-size: vw(183) vh(21);
                  background-repeat: no-repeat;
                  height: vh(21);
                  line-height: vh(21);
                  padding-left: vw(8);
                }
                .item-right-bottom-left-bottom {
                  width: vw(308);
                  height: vh(26);
                  line-height: vh(26);
                  padding-left: vw(8);
                }
              }
              .item-right-bottom-right {
                width: vw(54);
                line-height: vh(24);
                font-size: fontSize(14);
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                border-left: 1px solid rgba(20, 159, 129, 1);
                div:nth-child(1) {
                  font-size: fontSize(18);
                  font-weight: bold;
                }
              }
              .item-right-bottom-right-yellow {
                background: rgba(112, 84, 0, 1);
                color: rgba(255, 191, 0, 1);
              }
              .item-right-bottom-right-blue {
                background: rgba(0, 64, 62, 1);
                color: rgba(0, 255, 247, 1);
              }
            }
          }
        }
      }
    }
  }
  .left-part-2 {
    position: relative;
    margin-left: vw(40);
    margin-top: vh(30);
    .left-part-2-item {
      padding: 0;
      margin: 0;
      margin-bottom: vh(0);
    }
    .btn_open {
      position: absolute;
      right: vw(-960);
      bottom: vh(300);
      cursor: pointer;
      pointer-events: auto !important;
    }
    .btn_open_right {
      right: vw(-1280);
    }
    .btn_fold {
      position: absolute;
      left: vw(2);
      bottom: vh(246);
      cursor: pointer;
      pointer-events: auto !important;
    }
    .open_fold {
      position: absolute;
      right: vw(-1705);
      cursor: pointer;
      pointer-events: auto !important;
    }
  }
}

.farm-work-fixed-popup {
  position: fixed;
  top: vh(0);
  left: vw(410);
  width: vw(217);
  height: vh(292);
  background-image: url("../../assets/images/socializationIcon/block/farm-work.png");
  background-size: 100% 100%;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  padding: vh(30) vw(9) vh(9) vw(30);
  .popup-area {
    width: vw(160);
    min-height: vh(24);
    padding: vh(4) vw(6);
    background: #056e47;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
  }
  .popup-num {
    font-family: Microsoft YaHei;
    font-size: fontSize(14);
    color: #1bff81;
    display: flex;
    align-items: center;
    justify-content: center;
    width: vw(160);
  }
  .popup-list {
    font-family: Microsoft YaHei;
    height: vh(160);
    width: vw(168);
    margin-top: vh(2);
    padding: 0 0 0 vw(4);
    font-size: fontSize(12);
    color: rgba(248, 252, 255, 0.8);
    overflow: hidden;
    .popup-list-header {
      display: flex;
      justify-content: space-between;
      div {
        &:first-child {
          padding: vh(6) 0;
          width: vw(98);
          line-height: vh(16);
        }
        &:last-child {
          width: vw(60);
          display: flex;
          text-align: center;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
}

.farm-work-fixed-popup-seamless-warp {
  height: vh(160);
  overflow: hidden;
}

.scroll-container {
  height: vh(114);
  position: relative;
  overflow: hidden;
}

.farm-work-first {
  height: vh(38);
  position: relative;
  display: flex;
  align-items: center;
  font-size: fontSize(14);
  color: #ffffff;
  font-family: Microsoft YaHei;
  img {
    width: vw(44);
    height: vh(27);
    margin-top: vh(6);
  }
  .first {
    width: vw(44);
    height: vh(27);
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Furore;
    color: #b9ffdc;
    div {
      width: vw(23);
      height: vh(24);
      background-image: url("../../assets/images/socializationIcon/block/num-default.png");
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .second {
    width: vw(102);
    text-align: center;
    padding: 0 vw(6);
    text-align: center;
  }
  .third {
    width: vw(102);
    text-align: center;
  }
  .fourth {
    width: vw(148);
    padding-right: vw(8);
  }
}
.farm-work-first:nth-child(even) {
  background: rgba(0, 101, 51, 0.5);
}
.farm-work-first:hover {
  background: rgba(102, 76, 0, 0.5);
}

.date-picker {
  width: vw(162);
  height: vh(25);
  margin-right: vw(10);
  ::v-deep .el-date-editor {
    width: 100% !important;
    height: 100%;
    box-sizing: border-box;
    background: rgba(0, 78, 40, 0.8);
    border: 1px solid rgba(0, 78, 40, 0.8);
    border-radius: 4px;
    justify-content: space-around;
    .el-range-separator {
      color: #ffffff;
      line-height: vh(16);
      margin: 0 vw(2);
      padding: 0;
      width: 10%;
    }
    .el-input__icon {
      display: none;
    }
    .el-range-input {
      font-size: 14px;
      background: rgba(0, 78, 40, 0.8);
      color: #ffffff;
      &::placeholder,
      &::-webkit-input-placeholder {
        color: #ffffff;
      }
    }
  }
}

.hot-tabs,
.age-tabs {
  display: flex;
  div {
    display: flex;
    justify-content: center;
    width: vw(92);
    height: vh(29);
    line-height: vh(26);
    background-image: url("../../assets/images/socializationIcon/block/btn_tab.png");
    background-size: 100% 100%;
    font-size: fontSize(14);
    font-style: italic;
    cursor: pointer;
  }
  .hot-tab-active {
    background-image: url("../../assets/images/socializationIcon/block/btn_tab_c.png");
  }
}

.left-part-close {
  left: -22%;
  transition: all 300ms;
}

.right-part {
  position: absolute;
  top: vh(75);
  right: 0;
  display: flex;
  flex-direction: column;
  z-index: 60;
  width: vw(366);
  height: vh(666);
  right: 0;
  transition: all 300ms;
  overflow: hidden;
  .right-part-top {
    // height: vh(290);
    width: vw(366);
    background: linear-gradient(
      -90deg,
      rgba(4, 28, 12, 0.41),
      rgba(1, 10, 4, 0.1)
    );
    position: relative;
    border-bottom: 1px solid rgba(181, 181, 181, 1);
    .div_video {
      width: vw(366);
      height: vh(196);
      padding: vh(8) vw(8) 0 vw(8);
      position: relative;
      .div_video_mask {
        position: absolute;
        top: vh(2);
        bottom: vh(2);
        right: vw(20);
        left: vw(20);
        z-index: 20;
      }
      .div-video-player {
        width: vw(350);
        height: vh(185);
      }
      ::v-deep .video-js {
        height: 100%;
        width: 100%;
        .vjs-big-play-button {
          display: none !important;
        }
        .vjs-volume-panel {
          background: rgba(0, 0, 0, 0.5);
          position: absolute;
          bottom: 0;
          right: 0;
          width: vw(28);
          height: vh(28);
          border-radius: 6px 0px 0px 0px;
          z-index: 600;
          .vjs-volume-control.vjs-volume-vertical {
            display: none !important;
          }
          .vjs-mute-control {
            cursor: pointer;
            display: flex;
            padding: 0;
            .vjs-icon-placeholder {
              position: relative;
              width: vw(28);
              height: vh(28);
              display: flex;
            }
            .vjs-icon-placeholder:before {
              content: ""; /* 不需要使用 content 属性 */
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: vw(20); /* 图片宽度 */
              height: vh(16); /* 图片高度 */
              background-image: url("../../assets/images/socializationIcon/block/video/icon_voice_s.png"); /* 图片路径 */
              background-size: contain; /* 或者 contain，根据需求 */
              background-repeat: no-repeat;
              background-position: center; /* 图片位置 */
            }
          }
          .vjs-mute-control.vjs-vol-0 {
            .vjs-icon-placeholder:before {
              content: ""; /* 不需要使用 content 属性 */
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: vw(20); /* 图片宽度 */
              height: vh(16); /* 图片高度 */
              background-image: url("../../assets/images/socializationIcon/block/video/icon_voice_s_n.png"); /* 图片路径 */
              background-size: contain; /* 或者 contain，根据需求 */
              background-repeat: no-repeat;
              background-position: center; /* 图片位置 */
            }
          }
        }
      }
      ::v-deep .video-js .vjs-tech {
        object-fit: fill;
      }
      ::v-deep .vjs-poster {
        background-size: cover;
      }
      ::v-deep .video-js .vjs-volume-level {
        background-color: rgba(97, 255, 179, 1);
      }
      .controls {
        margin-top: 20px;
        text-align: center;
        position: absolute;
        top: vh(70);
        display: flex;
        width: vw(350);
        justify-content: space-between;
        img {
          pointer-events: auto !important;
          cursor: pointer;
          width: vw(14);
          height: vh(40);
        }
      }
      .open-dialog-btn {
        width: vw(40);
        height: vh(20);
        line-height: vh(20);
        position: absolute;
        right: vw(50);
        bottom: 0;
        color: #ffffff;
      }
    }
    .video-empty {
      width: vw(350);
      height: vh(197);
      margin: vh(8) vw(7) 0 vw(11);
      background-image: url("../../assets/images/socializationIcon/block/pic_sp_mrt.png");
      background-size: 100% 100%;
    }
    .video-title {
      margin-left: vw(8);
      width: vw(350);
      height: vh(28);
      line-height: vh(28);
      padding: 0 vw(4) 0 vw(16);
      background: rgba(0, 38, 17, 0.5);
      color: #ffffff;
      font-size: fontSize(14);
      overflow: hidden;
      white-space: nowrap;
    }
    .more-video {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: vh(280);
      background: rgba(0, 68, 30, 0.5);
      color: #ffffff;
      position: relative;
      transition: all 300ms;
      .more-video-list {
        flex: 1;
        padding: vh(0) 0;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        overflow-y: auto;
        .more-video-item {
          width: vw(165);
          height: vh(122);
          margin: vh(8) vw(8);
          cursor: pointer;
          img {
            width: 100%;
            height: vh(94);
          }
          div {
            font-size: fontSize(14);
            height: vh(36);
            line-height: vh(18);
          }
        }
        .video-active {
          img {
            border: 2px solid #1bff81;
          }
          div {
            color: rgba(27, 255, 129, 1);
          }
        }
      }
    }
    .more-video-btn {
      width: vw(366);
      height: vh(20);
      display: flex;
      align-items: center;
      justify-content: center;
      background-image: url("../../assets/images/socializationIcon/block/bg_more_video.png");
      background-size: 100% 100%;
      color: #ffffff;
      cursor: pointer;
    }
    .more-video-open {
      overflow: hidden;
      height: 0;
      transition: all 300ms;
    }
  }
  .right-part-bottom {
    height: vh(227);
    width: 100%;
    padding: vh(0) vw(16);
    background: linear-gradient(
      -90deg,
      rgba(4, 28, 12, 0.41),
      rgba(1, 10, 4, 0.1)
    );
    overflow: hidden;
    .knowledge-item-seamless-warp {
      margin-top: vh(8);
      height: vh(350);
      overflow: hidden;
      .knowledge-item {
        width: vw(334);
        margin-bottom: vh(8);
        padding: vh(7) vw(16);
        background: rgba(0, 38, 17, 0.5);
        font-size: fontSize(14);
        line-height: vh(21);
        color: #ffffff;
        .knowledge-item-title {
          font-size: fontSize(16);
          color: rgba(27, 255, 129, 1);
        }
        .knowledge-item-bottom {
          display: flex;
          flex: 1;
          .knowledge-item-bottom-left {
            margin-right: vw(10);
            flex: 1;
            .knowledge-item-department {
              height: vh(30);
              display: flex;
              align-items: center;
              font-size: fontSize(12);
              color: #b0ffd3;
              img {
                width: vw(16);
                height: vh(16);
                margin-right: vw(8);
              }
            }
            .knowledge-item-content {
              width: vw(192);
              height: vh(40);
              font-size: fontSize(14);
              color: #ffffff;
              p,
              span,
              strong {
                color: #ffffff !important;
              }
            }
          }
          .knowledge-item-bottom-right {
            width: vw(100);
            height: vh(56);
            margin-top: vh(12);
          }
        }
      }
    }
  }
  .seamless-warp-height {
    margin-top: 0;
    transition: all 300ms;
  }
  .seamless-warp-no-height {
    margin-top: vh(400);
    transition: all 300ms;
  }
  .knowledge-empty {
    width: vw(334);
    height: vh(335);
    margin: vh(8) vw(16);
    padding: 0 vw(50) 0 vw(65);
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: fontSize(24);
    color: rgba(6, 199, 128, 0.3);
    background: rgba(0, 38, 17, 0.5);
  }
}

.right-part-close {
  right: -50%;
  transition: all 300ms;
}

.right-fold-skill {
  position: absolute;
  top: vh(16);
  right: 0;
  width: vw(35);
  height: vh(167);
  z-index: 1000;
  color: #ffffff;
  font-size: fontSize(20);
  background: url("../../assets/images/socializationIcon/block/bg_njtgxc_tit.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.bottom-part {
  height: vh(236);
  z-index: 62;
  position: absolute;
  left: vw(430);
  display: flex;
  bottom: vh(60);
  transition: all 300ms;
  .bottom-part-1 {
    display: flex;
    flex-direction: column;
    width: vw(538);
    margin: 0 vw(14);
  }
  .bottom-part-2 {
    display: flex;
    flex-direction: column;
    width: vw(386);
    margin-right: vw(14);
  }
  .bottom-part-3 {
    width: vw(516);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .bottom-part-3-bottom {
      display: flex;
      .hot-podium {
        display: flex;
        align-items: flex-end;
        color: #ffffff;
        font-size: fontSize(12);
        div {
          width: vw(65);
          height: vh(175);
        }
        .first {
          background-image: url("../../assets/images/socializationIcon/block/pic_ranking_one.png");
          background-size: 100% 100%;
          padding-top: vh(70);
          div {
            padding: 0 vw(6);
            width: vw(65);
            height: vh(18);
            text-align: center;
          }
          .two-ellipsis-product {
            width: vw(65);
            height: vh(36);
            line-height: vh(17);
            text-align: center;
            word-wrap: break-word;
            word-break: break-all;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .second {
          background-image: url("../../assets/images/socializationIcon/block/pic_ranking_two.png");
          background-size: 100% 100%;
          padding-top: vh(90);
          div {
            padding: 0 vw(6);
            width: vw(65);
            height: vh(18);
            text-align: center;
          }
          .two-ellipsis-product {
            width: vw(65);
            height: vh(36);
            line-height: vh(17);
            text-align: center;
            word-wrap: break-word;
            word-break: break-all;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .third {
          background-image: url("../../assets/images/socializationIcon/block/pic_ranking_three.png");
          background-size: 100% 100%;
          padding-top: vh(110);
          div {
            padding: 0 vw(6);
            width: vw(65);
            height: vh(18);
            text-align: center;
          }
          .two-ellipsis-product {
            width: vw(65);
            height: vh(36);
            line-height: vh(17);
            text-align: center;
            word-wrap: break-word;
            word-break: break-all;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      .hot-rank {
        .hot-rank-header {
          display: flex;
          align-items: flex-end;
          height: vh(38);
          font-size: fontSize(14);
          color: #1bff81;
          .first {
            width: vw(44);
          }
          .second {
            width: vw(102);
            padding: 0 vw(6);
            text-align: center;
          }
          .third {
            width: vw(102);
            text-align: center;
          }
          .fourth {
            width: vw(76);
            text-align: center;
          }
        }
        .hot-rank-seamless-warp {
          height: vh(160);
          margin-left: vw(23);
          margin-top: vh(6);
          overflow: hidden;
          .hot-rank-item {
            display: flex;
            height: vh(38);
            margin-bottom: vh(4);
            background: url("../../assets/images/socializationIcon/block/bg_ranking.png")
              no-repeat left bottom;
            .hot-rank-item-left {
              width: vw(22);
              height: vh(28);
              padding-top: vh(3);
              margin-top: vh(5);
              background-image: url("../../assets/images/socializationIcon/block/icon_ranking_num.png");
              background-size: cover;
              display: flex;
              justify-content: center;
              font-size: fontSize(12);
              color: #ffffff;
              text-shadow: 0px 0px 4px #005535;
            }
            .hot-rank-item-right {
              display: flex;
              align-items: center;
              color: #ffffff;
              .first {
                width: vw(20);
              }
            }
          }
        }
        .emphot-rank-seamless-warp {
          margin-left: vw(23);
          height: vh(152);
          display: flex;
        }
      }
    }
  }
}

.bottom-part-close {
  bottom: -50%;
  transition: all 300ms;
}

.common-title {
  height: vh(38);
  flex: none;
  display: flex;
  align-items: center;
  color: #ffffff;
  justify-content: space-between;
  background: url("../../assets/images/socializationIcon/block/bg_title_nhrd.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .title {
    // margin-top: vh(-4);
    margin-left: vw(30);
    font-weight: bold;
    font-size: fontSize(20);
    color: #ffffff;
    text-shadow: 0px 2px 0px rgba(0, 9, 17, 0.34);
  }
  .special-margin {
    margin-left: vw(38);
  }
}

.type-icon-class {
  width: vw(127);
  height: vw(51);
  cursor: pointer;
}

.type-icon-last-class {
  width: vw(127);
  height: vw(59);
  cursor: pointer;
}

.map_container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  width: 100%;
  height: vh(1080);
  float: right;
}

.ellipsis {
  overflow: hidden; /* 确保文本超出容器时会被裁剪 */
  white-space: nowrap; /* 确保文本在一行内显示 */
  text-overflow: ellipsis; /* 显示省略号来表示文本被截断 */
}

.two-ellipsis {
  word-wrap: break-word;
  word-break: break-all;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}

.more-video-list::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 2px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.more-video-list::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 2px;
  background-color: #00af6f;
  background-image: -webkit-linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.2) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.2) 75%,
    transparent 75%,
    transparent
  );
}
.more-video-list::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #023f30;
  border-radius: 2px;
}

.title-animation {
  animation: scroll 6s linear infinite; /* 动画名称、持续时间、动画速度曲线、是否循环 */
}

@keyframes scroll {
  from {
    transform: translateX(50%); /* 从右边开始 */
  }
  to {
    transform: translateX(
      -100%
    ); /* 滚动到左边，然后由于无限循环，会从右边重新开始 */
  }
}
</style>
